module.exports = __webpack_public_path__ + "assets/img/suspension.aeabb082.png";